import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ReviewCard } from "../components/ContentCards";

export default function ReviewsPage() {
  const [items, setItems] = useState([]);
  const [type, setType] = useState("");
  useEffect(() => {
    const q = type ? `?review_type=${type}` : "";
    api.get(`/reviews${q}`).then((r) => setItems(r.data.items));
  }, [type]);
  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Header />
      <div className="container-page py-12 md:py-20">
        <div className="overline text-[#B4533C]">Reviews</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight mt-2">Tested. Verdicted.</h1>
        <div className="mt-8 flex gap-3 flex-wrap">
          {["", "airline", "hotel", "lounge", "card", "gear"].map((t) => (
            <button key={t || "all"} onClick={() => setType(t)} data-testid={`review-filter-${t || "all"}`}
              className={`border border-[#D6CFC4] px-4 py-2 text-xs font-mono uppercase tracking-wider ${type === t ? "bg-[#1B3B36] text-white" : "bg-white"}`}>
              {t || "All"}
            </button>
          ))}
        </div>
      </div>
      <div className="container-page pb-20 grid md:grid-cols-3 gap-8">
        {items.map((r) => <ReviewCard key={r.id} review={r} />)}
      </div>
      <Footer />
    </div>
  );
}
